module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/is-iterable.js
 ** module id = 373
 ** module chunks = 0
 **/